/*

    Module: jv.simple-select.directive
    Directive: simpleSelect

    The simplest select2 implementation for static data!

    Just set up your select element normally like so:

        <select simple-select[="{ optional select2 config }"] ng-model="model" ng-options="o.key as o.label for o in values"></select>

 */

angular.module('jv.simple-select.directive', [])
.directive('simpleSelect', [
    '$timeout', '$window',
    function($timeout, $window) {
        return {
            require: 'ngModel',
            link: function(scope, element, attributes) {
                // check for latest angular version
                var isAng17 = '1.7' === (angular.version.major+"."+angular.version.minor);

                function updateSelect2Value() {
                    if(isAng17){
                        $timeout(function() {
                            element.trigger('change.select2');
                        });
                    } else {
                        $timeout(function() {
                            element.trigger('change');
                        }, 0, false);
                    }
                }

                var options = angular.extend({
                    placeholder: i18n.SELECT_AN_OPTION,
                    minimumResultsForSearch: 8
                    }, ($window._jvPluginDefaults && $window._jvPluginDefaults.select2) || {}, scope.$eval(attributes.simpleSelect) || {});

                element.select2(options);

                scope.$watch(attributes.ngModel, function(val, prev) {
                    if (!angular.equals(val, prev)) {
                        if(isAng17) {
                            if(val){
                                // make select2 read the new checked state of the select options
                                if(angular.isArray(val)){
                                    var temp = [];
                                    for(var i=0; i<val.length; i++){
                                        angular.isNumber(val[i]) ? temp.push('number:'+val[i]) : temp.push('string:'+val[i]);
                                    }
                                    element.select2('val', temp);
                                } else if(angular.isNumber(val)){
                                    element.select2('val', 'number:'+val);
                                } else {
                                    element.select2('val', 'string:'+val);
                                }
                            }else{
                                element.select2('val', '');
                            }
                        }else{
                            // make select2 read the new checked state of the select options
                            updateSelect2Value();
                        }
                    }
                });
                // trigger chage to read initial value
                updateSelect2Value();
            }
        };
    }
]);